/**
 * Tailwind CSS implementation of Progress component
 * Uses Seeds progress CSS classes from progress.css
 */

import * as React from "react";
import * as RadixProgress from "@radix-ui/react-progress";
import type { TypeProgressProps } from "./ProgressTypes";

// Utility for merging class names properly
function cn(
  ...inputs: (string | undefined | null | false | Record<string, boolean>)[]
): string {
  const classes: string[] = [];

  for (const input of inputs) {
    if (!input) continue;

    if (typeof input === "string") {
      classes.push(input);
    } else if (typeof input === "object") {
      for (const [key, value] of Object.entries(input)) {
        if (value) {
          classes.push(key);
        }
      }
    }
  }

  return classes.join(" ");
}

export const ProgressTailwind = ({
  value,
  max = 100,
  getValueLabel,
  trackStyle,
  indicatorStyle,
  className,
  ...rest
}: TypeProgressProps) => {
  const percentage = max > 0 ? Math.min((value / max) * 100, 100) : 0;

  return (
    <RadixProgress.Root
      value={value}
      max={max}
      getValueLabel={getValueLabel}
      // Keep the literal "Progress" class so existing selectors (e.g. `.Progress`,
      // `.Progress > div`) continue to resolve. seeds-progress carries the styling.
      className={cn("Progress", "seeds-progress", className)}
      data-qa-progress=""
      style={trackStyle}
      {...(rest as any)}
    >
      <RadixProgress.Indicator
        className="seeds-progress-indicator"
        style={{
          transform: `translateX(-${100 - percentage}%)`,
          ...indicatorStyle,
        }}
      />
    </RadixProgress.Root>
  );
};

ProgressTailwind.displayName = "ProgressTailwind";
